<template>
  <img :src="pathImage" alt="Caminhão" width="70px" height="70px" />
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import pathImage from '../../../assets/mapa-industrial-dinamico/rondas.gif'

@Component({
  name: 'RondasIcon'
})
class RondasIcon extends Vue {
  pathImage = pathImage
}
export default RondasIcon
</script>
<style>

</style>
